export default {"src":"/_next/static/media/wintersport.ffc46fed.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};